import { Alert, AlertTitle } from '@folio/components';
import { AlertOctagonIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Group } from '@folio/components/ui/flex';
import { Text } from '@folio/components/ui/text';

export function WakamErrorBanner({ errorMessage }: { errorMessage: string | null }) {
  const { t } = useTranslation();

  if (!errorMessage) return null;

  return (
    <Alert variant="destructive" className="bg-card">
      <Group>
        <AlertOctagonIcon className="shrink-0" />
        <div>
          <AlertTitle>{t('errors.wakamPricingError')}</AlertTitle>
          <Text size="sm">{errorMessage}</Text>
        </div>
      </Group>
    </Alert>
  );
}
